import React, { useRef } from "react";
import { motion, useCycle } from "framer-motion";
import { Icon } from "@iconify/react";
import githubIcon from "@iconify-icons/mdi/github";
import linkedinIcon from "@iconify-icons/mdi/linkedin";
import { useDimensions } from "./use-dimensions";
import { MenuToggle } from "./MenuToggle";
import { Navigation } from "./Navigation";
import "./Styles.css";
import { Link, useLocation } from "react-router-dom";

const Layout = ({ children }) => {
  const sidebar = {
    open: (height = 1000) => ({
      clipPath: `circle(${height * 2 + 200}px at 40px 40px)`,
      transition: { type: "spring", stiffness: 20, restDelta: 2 },
    }),
    closed: {
      clipPath: "circle(30px at 40px 40px)",
      transition: { delay: 0.5, type: "spring", stiffness: 400, damping: 40 },
    },
  };

  const [isOpen, toggleOpen] = useCycle(false, true);
  const containerRef = useRef(null);
  const { height } = useDimensions(containerRef);
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="site">
      <header className="App-header">
        <div className="left-slot" />
        <Link to="/">
          <div className="logo" style={{ fontFamily: "'Meow Script', cursive" }}>
              Sabrina Quadir
          </div>

        </Link>
        <div className="icon-container">
          <a
            href="https://www.linkedin.com/in/sabrina-quadir-4543721b4/"
            target="_blank"
            rel="noreferrer"
          >
            <Icon icon={linkedinIcon} className="linkedin-icon" />
          </a>
          <a
            href="https://github.com/squadir10"
            target="_blank"
            rel="noreferrer"
          >
            <Icon icon={githubIcon} className="github-icon" />
          </a>
        </div>
      </header>

      <motion.nav
  className={isOpen ? "nav-open" : "nav-closed"}
  initial={false}
  animate={isOpen ? "open" : "closed"}
  custom={height}
  ref={containerRef}
  style={{ zIndex: 10 }}
>

        <motion.div className="background" variants={sidebar} />
        <Navigation />
      </motion.nav>

      <MenuToggle toggle={() => toggleOpen()} isOpen={isOpen} />

      <main className="site-main">{children}</main>

      {/* Full footer only on non-home pages */}
      {!isHome && (
        <footer className="footer">
          <h2 className="footer-header">Thanks for stopping by</h2>
          <p className="footer-subtext">
            Every connection starts with a hello, let's connect!
          </p>

          <div className="footer-icons">
            <a href="mailto:qsabrina64@gmail.com" className="footer-email-text">
              <Icon icon="mdi:email-outline" className="footer-icon" />
              <span className="footer-email-text" >qsabrina64@gmail.com</span>
            </a>
            <a
              href="https://github.com/squadir10"
              target="_blank"
              rel="noreferrer"
              className="footer-icon"
            >
              <Icon icon="mdi:github" />
            </a>
            <a
              href="https://www.linkedin.com/in/sabrina-quadir-4543721b4/"
              target="_blank"
              rel="noreferrer"
              className="footer-icon"
            >
              <Icon icon="mdi:linkedin" />
            </a>
          </div>

          <p className="footer-copy">© Sabrina Quadir, 2025</p>
        </footer>
      )}
    </div>
  );
};

export default Layout;
